import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import {
  wx_auth,
  already_wx_auth
} from './wx_auth'

import store from '@/store'
// import { debug } from 'util'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (!store.state.token && !store.state.openid && to.name !== 'auth') {
    // 登录入口 未授权 跳转到授权页面授权
    wx_auth(() => {
      next({
        name: 'auth'
      })
    })
  } else if (!store.state.token && store.state.openid && to.name !== 'login') {
    next({
      name: 'login'
    })
  } else if (store.state.token && store.state.openid && to.name === 'login') {
    next({
      name: 'member'
    })
  } else if (store.state.token && store.state.openid && to.name === 'member') {
    already_wx_auth(() => {
      next()
    })
  } else if (store.state.token && store.state.openid && to.name === 'store') {
    already_wx_auth(() => {
      next()
    })
  } else {
    next()
  }
})

router.afterEach(to => {
  window.scrollTo(0, 0)
})

export default router
